import { Component, Input, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';
import { InspectionActivityModel } from 'src/app/models/activities/inspection-request-activity';
import { CompleteInspectionActivity } from 'src/app/models/activities/complete-inspection-activity';

@Component({
    selector: 'wm-complete-inspection-activity-editor',
    templateUrl: './complete-inspection-activity-editor.component.html',
    styleUrls: ['./complete-inspection-activity-editor.component.css'],
    standalone: false
})
export class CompleteInspectionActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {
  
  @Input() activity: CompleteInspectionActivity;
  
  constructor() {
    super();
  }

  ngOnInit() {
    this.activity.model = (this.activity.model as InspectionActivityModel);
  }
}
